import { type SelectOptionType } from 'domains/banners/types/banner.types'
import {
  PlacementTypeEnum,
  PlacementStatusEnum,
  PlacementDestinationTypeEnum,
  PlacementExperimentMethodEnum,
  BannerLocaleEnum,
  ButtonVariantEnum,
} from 'domains/banners/api'

export const bannerTypes = {
  TEXT_WITH_THUMBNAIL: PlacementTypeEnum.TextWithThumbnail,
  IMAGE_FORWARD: PlacementTypeEnum.ImageForward,
  UNKNOWN: PlacementTypeEnum.Unknown,
  TEXT_WITH_THUMBNAIL_FLEX: PlacementTypeEnum.TextWithThumbnailFlex,
  IMAGE_FORWARD_FLEX: PlacementTypeEnum.ImageForwardFlex,
  HERO_BANNER: PlacementTypeEnum.HeroBanner,
  SECONDARY_BANNER: PlacementTypeEnum.SecondaryBanner,
  FLYOUT: PlacementTypeEnum.StandardInformationModal,
}

export const placementLocationOptions: SelectOptionType[] = [
  { value: 'WEB', labelKey: 'bannersDomain.platform.type.desktop-web' },
  { value: 'MOBILE', labelKey: 'bannersDomain.platform.type.mobile-web' },
  { value: 'IOS', labelKey: 'bannersDomain.platform.type.ios' },
  { value: 'ANDROID', labelKey: 'bannersDomain.platform.type.android' },
]

export const rankOptions: SelectOptionType[] = [
  { value: '0', labelKey: 'bannersDomain.banners.section.details.field.rank.label0' },
  { value: '1', labelKey: 'bannersDomain.banners.section.details.field.rank.label1' },
  { value: '2', labelKey: 'bannersDomain.banners.section.details.field.rank.label2' },
  { value: '3', labelKey: 'bannersDomain.banners.section.details.field.rank.label3' },
  { value: '4', labelKey: 'bannersDomain.banners.section.details.field.rank.label4' },
  { value: '-80', labelKey: 'bannersDomain.banners.section.details.field.rank.label_80' },
  { value: '-79', labelKey: 'bannersDomain.banners.section.details.field.rank.label_79' },
  { value: '-78', labelKey: 'bannersDomain.banners.section.details.field.rank.label_78' },
  { value: '-77', labelKey: 'bannersDomain.banners.section.details.field.rank.label_77' },
  { value: '-76', labelKey: 'bannersDomain.banners.section.details.field.rank.label_76' },
]

export const filterOptions: { [key: string]: SelectOptionType[] } = {
  type: [
    {
      value: bannerTypes.HERO_BANNER,
      labelKey: 'bannersDomain.banners.type.heroBanner',
    },
    {
      value: bannerTypes.SECONDARY_BANNER,
      labelKey: 'bannersDomain.banners.type.secondaryBanner',
    },
    {
      value: bannerTypes.FLYOUT,
      labelKey: 'bannersDomain.banners.type.flyout',
    },
  ],
  status: [
    { value: PlacementStatusEnum.Active, labelKey: 'bannersDomain.list.status.active' },
    { value: PlacementStatusEnum.Inactive, labelKey: 'bannersDomain.list.status.inactive' },
  ],
  platform: placementLocationOptions,
}

export const bannerStyleVariants = {
  primary: ButtonVariantEnum.Primary,
  secondary: ButtonVariantEnum.Secondary,
  link: ButtonVariantEnum.Link,
  plus: ButtonVariantEnum.Plus,
}

export const bannerDestinationTypes = {
  doNotNavigate: PlacementDestinationTypeEnum.DoNotNavigate,
  external: PlacementDestinationTypeEnum.External,
  storefront: PlacementDestinationTypeEnum.Storefront,
  storeSelector: PlacementDestinationTypeEnum.StoreSelector,
  pickupStoreSelector: PlacementDestinationTypeEnum.PickupStoreselector,
  containerPathViaStoreSelector: PlacementDestinationTypeEnum.ContainerPathViaStoreSelector,
  unknown: PlacementDestinationTypeEnum.Unknown,
}

export const visibilityConditionTypes = {
  countryIds: 'ContentManagementVisibilityConditionCountryIds',
  dayOfWeek: 'ContentManagementVisibilityConditionDayOfWeek',
  expressMembership: 'ContentManagementVisibilityConditionExpressMembership',
  expressNonmemberLongTermHoldout:
    'ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout',
  matchesAnyRetailerId: 'ContentManagementVisibilityConditionMatchesAnyRetailerId',
  minimumPlatformVersion: 'ContentManagementVisibilityConditionMinimumPlatformVersion',
  retailerAvailability: 'ContentManagementVisibilityConditionRetailerAvailability',
  shoppedAtRetailer: 'ContentManagementVisibilityConditionShoppedAtRetailer',
  shopped: 'ContentManagementVisibilityConditionShopped',
  userInteractionLimit: 'ContentManagementVisibilityConditionUserInteractionLimit',
  whitelistedPostalCodes: 'ContentManagementVisibilityConditionWhitelistedPostalCodes',
  whitelistedZones: 'ContentManagementVisibilityConditionWhitelistedZones',
}

export const localeOptions: SelectOptionType[] = [
  {
    value: BannerLocaleEnum.EnUs,
    labelKey: 'bannersDomain.flyoutForm.form.locale.en-us.label',
  },
  {
    value: BannerLocaleEnum.EnCa,
    labelKey: 'bannersDomain.flyoutForm.form.locale.en-ca.label',
  },
  {
    value: BannerLocaleEnum.FrCa,
    labelKey: 'bannersDomain.flyoutForm.form.locale.fr-ca.label',
  },
]

export const styleOptions: SelectOptionType[] = [
  {
    value: bannerStyleVariants.primary,
    labelKey: 'bannersDomain.bannersForm.form.link-destination.input.style.option.primary',
  },
  {
    value: bannerStyleVariants.secondary,
    labelKey: 'bannersDomain.bannersForm.form.link-destination.input.style.option.secondary',
  },
  {
    value: bannerStyleVariants.link,
    labelKey: 'bannersDomain.bannersForm.form.link-destination.input.style.option.link',
  },
  // {
  //   value: ButtonVariantEnum.Detrimental,
  //   labelKey:
  //     'bannersDomain.bannersForm.form.link-destination.input.style.option.detrimental',
  // },
  {
    value: bannerStyleVariants.plus,
    labelKey: 'bannersDomain.bannersForm.form.link-destination.input.style.option.plus',
  },
]

export const placementDestinationOptions: SelectOptionType[] = [
  {
    value: bannerDestinationTypes.doNotNavigate,
    labelKey:
      'bannersDomain.bannersForm.form.link-destination.input.destinationType.option.doNotNavigate',
  },
  {
    value: bannerDestinationTypes.external,
    labelKey:
      'bannersDomain.bannersForm.form.link-destination.input.destinationType.option.external',
  },
  {
    value: bannerDestinationTypes.storefront,
    labelKey:
      'bannersDomain.bannersForm.form.link-destination.input.destinationType.option.storefront',
  },
  {
    value: bannerDestinationTypes.storeSelector,
    labelKey:
      'bannersDomain.bannersForm.form.link-destination.input.destinationType.option.storeSelector',
  },
  {
    value: bannerDestinationTypes.pickupStoreSelector,
    labelKey:
      'bannersDomain.bannersForm.form.link-destination.input.destinationType.option.pickupStoreSelector',
  },
  {
    value: bannerDestinationTypes.unknown,
    labelKey:
      'bannersDomain.bannersForm.form.link-destination.input.destinationType.option.unknown',
  },
]

export const placementExperimentMethodOptions: SelectOptionType[] = [
  {
    value: PlacementExperimentMethodEnum.Assign,
    labelKey: 'bannersDomain.experiment.access-method.assign',
  },
  {
    value: PlacementExperimentMethodEnum.Lookup,
    labelKey: 'bannersDomain.experiment.access-method.lookup',
  },
  {
    value: PlacementExperimentMethodEnum.Preview,
    labelKey: 'bannersDomain.experiment.access-method.preview',
  },
  {
    value: PlacementExperimentMethodEnum.ExperimentMethodUnspecified,
    labelKey: 'bannersDomain.experiment.access-method.none',
  },
]
